import * as React from 'react';
import { CoreRadioButton } from '../internal/WixUiCoreComponents/components/CoreRadioButton';
import { st, classes } from './RadioButton.st.css';
import classnames from 'classnames';
import { RadioButtonTheme, RadioButtonDataKeys, RadioButtonDataHooks, } from './types';
import { ErrorMessageWrapper } from '../internal/ErrorMessageWrapper';
import uniqueId from '../../common/uniqueId';
/** Radio button icon */
const radioBtnIcon = (isChildren) => (React.createElement("div", { className: classnames(classes.radioIcon, {
        [classes.withChildren]: isChildren,
    }) },
    React.createElement("div", { className: st(classes.innerCheck) })));
/** RadioButton **/
export class RadioButton extends React.Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.state = {
            focused: false,
        };
        this._getAriaLabel = () => {
            const { label } = this.props;
            return this.props['aria-label'] ? this.props['aria-label'] : label;
        };
        this._getAriaDescribedBy = () => {
            const { subtext } = this.props;
            return !subtext || this.props['aria-describedby']
                ? this.props['aria-describedby']
                : this._subtextId;
        };
        this._getContent = (suffix, subtext, label, children) => {
            if (children) {
                return children;
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: classes.labelWrapper },
                    ' ',
                    React.createElement("div", { "data-hook": RadioButtonDataHooks.LabelWrapper, className: classnames(classes.label, {
                            [classes.suffixed]: !!suffix,
                        }) }, label),
                    suffix && (React.createElement("div", { className: `${classes.label} ${classes.suffix}` }, suffix))),
                subtext && (React.createElement("div", { id: this._subtextId, "data-hook": RadioButtonDataHooks.SubtextWrapper, className: classes.subtext }, subtext))));
        };
        this._onFocus = () => {
            this.setState({ focused: true });
        };
        this._onBlur = (event) => {
            this.setState({ focused: false });
            const { onBlur } = this.props;
            if (onBlur) {
                onBlur(event);
            }
        };
        this.focus = () => {
            if (this.inputRef.current) {
                this.inputRef.current.focus();
                /** Manually update focus state
                 * usually set to true on keyboard focus */
                this.setState({ focused: true });
            }
        };
        this.blur = () => {
            this.inputRef.current?.blur();
        };
        this._subtextId = uniqueId('radio-button-subtext');
        this._errorMessageId = uniqueId('error-message');
    }
    _getDataAttributes() {
        const { checked, disabled, required } = this.props;
        const { focused } = this.state;
        return {
            [RadioButtonDataKeys.Checked]: checked,
            [RadioButtonDataKeys.Disabled]: disabled,
            [RadioButtonDataKeys.Focused]: focused,
            [RadioButtonDataKeys.Required]: required,
        };
    }
    render() {
        const { checked, disabled, value, label, name, onChange, onFocus, className, error, errorMessage, errorAppearance, theme, subtext, suffix, required, children, newErrorMessage, lang, unstableHasInnerWrapper = true, } = this.props;
        const Wrapper = newErrorMessage ? ErrorMessageWrapper : React.Fragment;
        const box = theme === 'box' ? true : false;
        const stStatesOnWrapper = { disabled, error, box, newErrorMessage };
        const stStatesOnInnerWrapper = { disabled, error, box, checked };
        const isErrorMessageProvided = errorMessage && errorMessage.length > 0;
        const containerClassName = !newErrorMessage || !isErrorMessageProvided
            ? st(classes.root, stStatesOnInnerWrapper, className)
            : classes.container;
        const focusClassName = this.state.focused &&
            st(classes.focused, { hasInnerWrapper: unstableHasInnerWrapper });
        return (React.createElement(Wrapper, { ...(newErrorMessage && {
                visible: error && isErrorMessageProvided,
                message: errorMessage,
                errorAppearance,
                messageId: this._errorMessageId,
                className: st(classes.root, stStatesOnWrapper, className),
                'data-hook': this.props['data-hook'],
                lang,
            }) },
            React.createElement("div", { className: st(containerClassName, focusClassName), "data-hook": this.props['data-hook'], ...(!newErrorMessage ? { lang } : {}), ...this._getDataAttributes() },
                React.createElement(CoreRadioButton, { "data-hook": RadioButtonDataHooks.coreRadioButton, checked: checked, disabled: disabled, required: required, ref: this.inputRef, tabIndex: 0, value: value, onFocusByKeyboard: this._onFocus, onFocus: onFocus, onBlur: this._onBlur, label: this._getContent(suffix, subtext, label, children), name: name, onChange: onChange, checkedIcon: radioBtnIcon(!!children), uncheckedIcon: radioBtnIcon(!!children), "aria-label": this._getAriaLabel(), "aria-describedby": this._getAriaDescribedBy(), "aria-labelledby": this.props['aria-labelledby'], className: classes.wrapper, unstableHasInnerWrapper: unstableHasInnerWrapper }))));
    }
}
RadioButton.displayName = 'RadioButton';
RadioButton.defaultProps = {
    checked: false,
    disabled: false,
    error: false,
    name: '',
    theme: RadioButtonTheme.Default,
};
//# sourceMappingURL=RadioButton.js.map